import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild  } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from '@angular/common';


import { GestockService } from '../services/gestock.service';

@Component({
  selector: 'app-depot-dialog',
  templateUrl: './depot-dialog.component.html',
  styleUrls: ['./depot-dialog.component.css']
})
export class DepotDialogComponent implements OnInit {

  isEditMode: boolean = false;

  product : any ;

  depot : any ;

  nomDepot : any ;

  qteEnStock = 0 ;
  entryPrice = 0 ;

  retourClientWS : any ;

  samacaabiyoonwii : any ;
  allPoints : any;
  choosedPoint : any;

  tousLesDepots = [] ;

  etatreq = "" ;

  selectedBoutique = "";

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;

  constructor(
    private dialogRef: MatDialogRef<DepotDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configServer: GestockService, 
                         public dialog: MatDialog ,
                         private _adapter: DateAdapter<any>,
                         @Inject(MAT_DATE_LOCALE) private _locale: string) {

    this.isEditMode = data.mode === 'edit';
    console.log("EDIT MODE: ", this.isEditMode) ;

    this.product = data.product ;
    this.depot = data.depot ;
    this.selectedBoutique = data.boutique ;
  }

  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;

    if( this.isEditMode==false )
      this.getAllPointsEtDepots() ;
  }


  getAllPointsEtDepots(){
    this.configServer.getAllPointsEtDepots(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ;
        this.retenirJusteLesDepots() ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  onLieuxStructChange(event){
    this.choosedPoint = this.tousLesDepots[event.value] ;    
  }

  retenirJusteLesDepots(){
    for (var i = 0; i < this.allPoints.length; i++) {
      if(this.allPoints[i].type=="Depot"){
        if( !this.inPrevDepots(this.allPoints[i].nompoint) )
          this.tousLesDepots.push(this.allPoints[i]) ;
      }
    }
  }

  inPrevDepots(nomdepot){
    for (var i = 0; i < this.product.quantity.stocksParDepot.length; i++) {
      if(this.product.quantity.stocksParDepot[i].nomDepot==nomdepot)
        return true ;
    }
    return false ;
  }

  ajouterDepot(newDepot){
    this.openSpinnerDialog() ;
    this.configServer.ajouterDepot(this.samacaabiyoonwii, this.product.quantity.stocksParDepot[0].idstock, 
                      newDepot, this.entryPrice, this.product).then( (retourbi) => {

      this.closeSpinnerDialog();
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }


  mettreAjourStockDepot(){
    this.openSpinnerDialog() ;
    this.configServer.mettreAjourStockDepot(this.samacaabiyoonwii, this.depot.idstock,
             this.qteEnStock, this.entryPrice, this.product).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }


  onSave() {
    if(this.isEditMode==false){
      let newDepot = {"nomDepot":this.choosedPoint.nompoint, "qteEnStock": this.qteEnStock} ;
      this.ajouterDepot(newDepot);

    }else{
      this.mettreAjourStockDepot();
    }
  }

  saisieconforme(){
    if(this.isEditMode==true){
      return (this.entryPrice>0) ;
    }
      return (this.choosedPoint!=undefined && this.entryPrice>0) ;
  }



  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


  close() {
    this.dialogRef.close();
  }

  onCancel() {
    this.dialogRef.close();
  }
}
